import { useRef } from 'react';
import { RefNames } from '../types';

export const useRefs = () => {
  const workHistoryRef = useRef<HTMLDivElement>(null);
  const publicationsRef = useRef<HTMLDivElement>(null);
  const volunteerRef = useRef<HTMLDivElement>(null);
  const certificationRef = useRef<HTMLDivElement>(null);
  const projectsRef = useRef<HTMLDivElement>(null);
  const educationRef = useRef<HTMLDivElement>(null);
  const recommendationsRef = useRef<HTMLDivElement>(null);
  const languagesRef = useRef<HTMLDivElement>(null);

  return {
    workHistoryRef,
    publicationsRef,
    volunteerRef,
    certificationRef,
    projectsRef,
    educationRef,
    recommendationsRef,
    languagesRef,
  } as RefNames;
};
